// iter417 — Dashboard "Alerts" section wrapper.
// Aggregates the four alert-style widgets (Branch loss · Data entry ·
// Budget · Compliance) under a single DashboardSection. Visibility
// rolls up: section renders only when at least one inner card has
// content to show — saves an empty band on quiet days.
import { useState } from 'react';
import { DashboardSection } from './DashboardSection';
import { BranchLossAlertsCard } from './BranchLossAlertsCard';
import { DataEntryAlertsCard } from './DataEntryAlertsCard';
import BudgetAlertsWidget from '@/pages/dashboard/widgets/BudgetAlertsWidget';
import ComplianceHealthWidget from '@/pages/dashboard/widgets/ComplianceHealthWidget';

const TOP = 5;

export function AlertsSection({
  stats,
  missingDataAlerts = [],
  budgetAlertsSummary,
  widgets = {},
  showWidget = () => true,
  cardClass = '',
}) {
  const [showAll, setShowAll] = useState(false);
  const hasBranchLoss = showWidget('branch_pnl') && (stats?.branch_loss_alerts?.length || 0) > 0;
  const hasMissingData = missingDataAlerts.length > 0;
  const hasBudget = !!widgets.budgetAlerts;
  const hasCompliance = !!widgets.complianceHealth;
  const visible = hasBranchLoss || hasMissingData || hasBudget || hasCompliance;
  if (!visible) return null;
  const branchLoss = stats?.branch_loss_alerts || [];
  const total = (hasBranchLoss ? branchLoss.length : 0) + missingDataAlerts.length + (budgetAlertsSummary?.total_active || 0);
  const more = branchLoss.length > TOP || missingDataAlerts.length > TOP;
  const top = (list) => (showAll ? list : list.slice(0, TOP));

  return (
    <DashboardSection
      title={`Alerts${total ? ` (${total})` : ''}`}
      testId="dash-section-alerts"
      right={more ? (
        <button type="button" onClick={() => setShowAll(v => !v)} data-testid="dash-alerts-view-all"
          className="text-xs font-medium text-primary hover:underline">{showAll ? 'Show top 5' : 'View all'}</button>
      ) : null}
    >
      <div className="grid grid-cols-1 xl:grid-cols-2 gap-6 items-start">
        {hasBranchLoss && (
          <BranchLossAlertsCard alerts={top(branchLoss)} />
        )}
        <DataEntryAlertsCard alerts={top(missingDataAlerts)} />
        {hasBudget && (
          <BudgetAlertsWidget budgetAlertsSummary={budgetAlertsSummary} cardClass={cardClass} />
        )}
        {hasCompliance && (
          <ComplianceHealthWidget cardClass={cardClass} />
        )}
      </div>
    </DashboardSection>
  );
}

export default AlertsSection;
